module.exports = __webpack_public_path__ + "img/logo_iut_nancy_charlemagne.efd9bfce.png";